import axios from "@/plugins/axios-setting";

export function getTags(): Promise<[]> {
  return axios.get("/api/tags/");
}

export function addTag(tag: object): Promise<any> {
  return axios.post("/api/tags/", tag);
}
